import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Search, MessageCircle, Plus, User, LogIn, Calendar } from 'lucide-react';
import BottomNavigation from "@/components/BottomNavigation";
import { useUser } from "@/contexts/UserContext";

const Index = () => {
  const [activeTab, setActiveTab] = useState('home');
  const { user } = useUser();
  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    switch (tab) {
      case 'home':
        navigate('/');
        break;
      case 'marketplace':
        navigate('/marketplace');
        break;
      case 'berichten':
        navigate('/berichten');
        break;
      case 'vacatures':
        navigate('/vacatures');
        break;
      case 'profiel':
        navigate('/profiel');
        break;
    }
  };

  const mainFunctions = [
    {
      title: "WOM Plaza",
      description: "Ontdek diensten en producten van vrouwen",
      icon: Search,
      onClick: () => {
        console.log("Navigating to WOM Plaza");
        navigate('/marketplace');
      }
    },
    {
      title: "Test Pagina",
      description: "Bekijk de app status en test alle functies",
      icon: MessageCircle,
      onClick: () => {
        console.log("Navigating to Test");
        navigate('/test');
      }
    },
    {
      title: "Dienst Plaatsen",
      description: "Deel je diensten met de bewuste vrouwen gemeenschap",
      icon: Plus,
      onClick: () => {
        console.log("Navigating to Post Service form");
        navigate('/dienst-plaatsen');
      }
    },
    {
      title: "Inloggen",
      description: "Log in om alle functies te gebruiken",
      icon: User,
      onClick: () => {
        console.log("Navigating to Login");
        navigate('/login');
      }
    },
    {
      title: "Berichten",
      description: "Chat met andere vrouwen over diensten en projecten",
      icon: MessageCircle,
      onClick: () => {
        console.log("Navigating to Messages");
        navigate('/berichten');
      }
    },
    {
      title: "Afspraken Beheren",
      description: "Plan en bekijk je afspraken en boekingen",
      icon: Calendar,
      onClick: () => {
        console.log("Navigating to Appointments");
        navigate('/agenda');
      }
    },
    {
      title: "Mijn Profiel",
      description: "Bekijk en bewerk je profielinformatie",
      icon: User,
      onClick: () => {
        console.log("Navigating to Profile");
        navigate('/profiel');
      }
    }
  ];
  return (
    <div className="min-h-screen bg-elegant pb-24">
      {/* Main Content */}
      <div className="px-6 pt-16 pb-8">
        {/* Welcome Section */}
        <div className="max-w-2xl mx-auto text-center mb-12">          
          {/* Hero Section - Elegant Professional */}
          <div className="card-premium p-8 mb-8">
            <div className="mb-6">
              <h1 className="text-5xl md:text-6xl font-light text-navy-900 mb-2 tracking-wider">
                <span className="font-bold text-navy-800">W</span>
                <span className="mx-2 text-gold-400">·</span>
                <span className="font-bold text-navy-800">O</span>
                <span className="mx-2 text-gold-400">·</span>
                <span className="font-bold text-navy-800">M</span>
              </h1>
              <p className="script-text text-2xl mb-6 text-navy-700">
                Woman on a Mission
              </p>

              <p className="text-lg font-normal leading-relaxed text-navy-600">
                Voor vrouwen die hun dromen waarmaken,<br />
                hun passie delen en samen groeien
              </p>
            </div>
          </div>

          <div className="card-premium p-6 mb-8">
            <p className="font-medium text-lg text-navy-800">
              Ready om je mission te starten?
            </p>
          </div>
        </div>

        {/* Function Cards */}
        <div className="max-w-2xl mx-auto space-y-4">
          {mainFunctions.map((func, index) => (
            <div key={index} className="card-premium-hover">
              <div 
                className="flex items-center p-6 cursor-pointer group"
                onClick={func.onClick}
              >
                <div className="flex-shrink-0 w-12 h-12 bg-navy-100 rounded-lg flex items-center justify-center group-hover:bg-navy-200 transition-colors">
                  <func.icon className="h-6 w-6 text-navy-700" />
                </div>
                <div className="ml-4 flex-1">
                  <h3 className="text-lg font-serif text-navy-800 group-hover:text-navy-900 transition-colors">
                    {func.title}
                  </h3>
                  <p className="text-sm text-navy-600 group-hover:text-navy-700 transition-colors">
                    {func.description}
                  </p>
                </div>
                <div className="ml-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-gold-400 rounded-full"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* WOM Quote Section */}
        <div className="max-w-2xl mx-auto mt-12">
          <div className="card-premium p-8 text-center">
            <div className="mb-4">
              <div className="w-16 h-16 bg-gradient-to-r from-gold-400 to-gold-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">WOM</span>
              </div>
            </div>
            <blockquote className="script-text text-xl text-navy-800 mb-4 italic">
              "Samen zijn we sterker, samen maken we impact"
            </blockquote>
            <p className="text-sm text-navy-600">
              Sluit je aan bij duizenden vrouwen die hun passie volgen 
              en elkaar helpen groeien
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation />
    </div>
  );
};
export default Index;